import { JObject } from "../../../../../common/data/models";
import { buildFilterMetaToObject, buildSortParamsToString, PaginatedRequestParams, PaginatedResponse, Result } from "../../../../../common/pagination";
import { endpoints } from "../../../../../constants/endpoints";
import { tawreedHttpService } from "../../../../../http";
import { StoreProductQuantityLimitationMapper } from "../mappers";
import { StoreProductQuantityLimitation } from "../models";

export class ProductQuantityLimitationRepository {

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<StoreProductQuantityLimitation>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };

        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.STORE_PRODUCTS_QUANTITY_LIMITATION_SAERCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => StoreProductQuantityLimitationMapper.fromJson(e)) ?? [] },
                };
            });
    }

    /**
         * Create or update 
         * @param type
         * @param form
         */
    public async createOrUpdate(data: StoreProductQuantityLimitation): Promise<StoreProductQuantityLimitation> {
        return tawreedHttpService.post<JObject, JObject>(endpoints.STORE_PRODUCTS_QUANTITY_LIMITATION_CREATE_OR_SAVE, 
            StoreProductQuantityLimitationMapper.toJson(data)   
        )
            .then(res => {

                return StoreProductQuantityLimitationMapper.fromJson(res.data!);
            });
    }

    /**
     * Delete 
     * @param id
     */
    public async delete(id: number): Promise<boolean> {
        return tawreedHttpService.post<number, number>(endpoints.STORE_PRODUCTS_QUANTITY_LIMITATION_DELETE, id).then(res => {
            return res.status === 200
        });
    }

    public async deleteAll(ids: number[]): Promise<boolean> {
        return tawreedHttpService.post<number[], number>(endpoints.STORE_PRODUCTS_QUANTITY_LIMITATION_DELETE_ALL, ids).then(res => {
            return res.status === 200
        });
    }

    public async getDetails(id: number): Promise<StoreProductQuantityLimitation> {
            return tawreedHttpService.post<number, JObject>(endpoints.STORE_PRODUCTS_QUANTITY_LIMITATION_GET, id, undefined, undefined, 'error')
            .then(res => StoreProductQuantityLimitationMapper.fromJson(res.data!));
        }
}